import {WindowHelper} from "../../Classes/WindowHelper";

export class HoverBlock{
    constructor(root_node) {
        this.root_node = root_node;
        this.circle = this.root_node.querySelector('.hover-block__hover');

        this.windowHelper = new WindowHelper();

        if(this.windowHelper.width < 600){
            this.root_node.classList.add('hover-block--mobile');
        }
        else{
            this.root_node.classList.remove('hover-block--mobile');
        }

        this.init_events();
    }

    init_events(){
        if(this.windowHelper.width < 600){
            return;
        }

        this.root_node.addEventListener('mouseenter', (e) => {
            const bounds = this.root_node.getBoundingClientRect();
            this.move_custom_mouse(e.clientX, e.clientY, this.circle, bounds);
        });

        this.root_node.addEventListener('mousemove', (e) => {
            const bounds = this.root_node.getBoundingClientRect();
            this.move_custom_mouse(e.clientX, e.clientY, this.circle, bounds);
        });
    }

    move_custom_mouse(x, y, circle, bounds)
    {
        circle.style.left = x - bounds.left + 'px';
        circle.style.top = y - bounds.top + 'px';
    }
}
